import React from "react";

const Hero = () => {
	return (
		<div className="bg-white flex flex-col sm:flex-row items-center justify-between py-16 lg:w-[75%] mx-auto">
			<div className="flex flex-col justify-center h-max w-full p-5">
				<h1 className="text-4xl lg:text-5xl text-slate-800 font-bold">Automate Manual Data Entry Using AI</h1>
				<p className="text-slate-700">Capture data from documents instantly. Reduce turn around times and the manual effort required.</p>
				<button className="border-2 border-primary-500 hover:bg-primary-500 text-primary-500 hover:text-white px-5 py-2 w-32 rounded-md mt-5 transition-all duration-300 shadow hover:shadow-lg">Get Started</button>
			</div>
			<div className="w-full sm:max-w-[50%] p-5">
				<img src="/static/images/hero.jpeg" className="" />
			</div>
		</div>
	);
};

export default Hero;
